import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { LabelType, Options } from '@angular-slider/ngx-slider';
import { Component, Input, OnInit, Output, EventEmitter, OnChanges, Inject, ChangeDetectorRef } from '@angular/core';
import { removeDuplicateFromArray } from 'src/app/functions/shared-functions';
import { ControlSharedService } from '../../services/control-shared/control-shared.service';
import { AddResumeSkillsComponent } from 'src/app/modules/jobseeker-registration/components/add-resume-skills/add-resume-skills.component';

@Component({
  selector: 'app-skill-rating',
  templateUrl: './skill-rating.component.html',
  styleUrls: ['./skill-rating.component.scss'],
  providers: [ControlSharedService]
})
export class SkillRatingComponent implements OnInit, OnChanges {
  options: any = [];
  loaded = false;
  raking_title = [{
    id: 1,
    title: 'Learner'
  },
  {
    id: 2,
    title: "Beginner"
  }, {
    id: 3,
    title: "Familiar"
  }, {
    id: 4,
    title: "Independent"
  }, {
    id: 5,
    title: "Expert"
  }
  ]
  type = 1;
  statusList = [
    {
      id: 2,
      title: 'Any'
    },
    {
      id: 1,
      title: 'Active'
    },
    {
      id: 0,
      title: 'Inactive'
    },
  ];
  width = '25%'
  slider_options: Options = {
    floor: 1,
    ceil: 5,
    translate: (value: number, label: LabelType): string => {
      switch (label) {
        case LabelType.Low:
          switch (value) {
            case 1: {
              return 'Learner';

            };
            case 2: {
              return 'Beginner';

            };
            case 3: {
              return 'Familiar';

            };
            case 4: {
              return 'Independent';

            };
            case 5: {
              return 'Expert';

            }
          }
        case LabelType.High:
          switch (value) {
            case 1: {
              return 'Learner';

            };
            case 2: {
              return 'Beginner';

            };
            case 3: {
              return 'Familiar';

            };
            case 4: {
              return 'Independent';

            };
            case 5: {
              return 'Expert';

            }
          }
        default:
          return "$" + value;
      }
    }
  };
  skillForm: UntypedFormGroup = new UntypedFormGroup({
    keySkills: new UntypedFormControl(null),
  })
  skillList = [];
  manageKeySkillsRef: Function;
  skillManagerForm: UntypedFormGroup = new UntypedFormGroup({})
  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private dialog_ref: MatDialogRef<SkillRatingComponent>,
    private change_detector: ChangeDetectorRef,
    private ctrl_srv: ControlSharedService,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.manageKeySkillsRef = this.manageKeySkills.bind(this)
    if (this.data) {
      this.type = this.data.type || 1;
      if (this.data.enableSkill) {
        this.loadPrimarySkills();
        this.skillForm.controls.keySkills.patchValue(this.data.keySkills);

      }
      if (this.data.options && this.data.options.length && this.type == 2) {
        for (let i = 0; i < this.data.options.length; i++) {
          this.skillManagerForm.addControl(i.toString(), new UntypedFormControl(this.data.options[i].status == 3 ? 2 : this.data.options[i].status));
        }
      }
      this.options = this.data.options;
      setTimeout(() => {
        this.loaded = true
      }, 200)

    }
  }


  manageKeySkills(ev) {

    this.dialog.open(AddResumeSkillsComponent, {
      width: '40%',
      height: 'auto',
      panelClass: "TM-Dialog",
      disableClose: true,
    }).afterClosed().subscribe(data => {
      if (data && data.length) {
        let skills = this.skillForm.value.keySkills;
        skills = [...skills, ...data];
        skills = removeDuplicateFromArray(skills);
        this.loadPrimarySkills(skills)
      }
    })

  }

  formatLabel(value: number) {
    let title = '';
    switch (value) {
      case 1: {
        title = 'Learner';
        break;
      };
      case 2: {
        title = 'Beginner';
        break;
      };
      case 3: {
        title = 'Familiar';
        break;
      };
      case 4: {
        title = 'Independent';
        break;
      };
      case 5: {
        title = 'Expert';
        break;
      }

    }
    return value;

  }
  loadPrimarySkills(list?) {
    this.ctrl_srv.getPrimarySkills({
      type: 0,
      skillCatCode: 0,
      startPage: 1,
      limit: 1000
    }).subscribe(res => {
      if (res && res['data']) {
        this.skillList = res['data'].list;
        if (this.options && this.options.length) {
          this.options.forEach(op => {
            let index = this.skillList.findIndex(data => data.skillCode == op.skillCode);
            if (index > -1) {
              this.skillList[index] = op;
            }
          })
        }
        if (list) {
          this.skillForm.controls.keySkills.patchValue(list);
        }
      }
    })
  }
  loadSkills(ev) {
    if (ev && ev.length) {
      let save_skills = this.options
      if (save_skills && save_skills.length) {
        ev.forEach(comingSkill => {
          let index = save_skills.findIndex(data => data.skillCode == comingSkill.skillCode);
          if (index > -1) {
            let data = save_skills[index]
            comingSkill['skillLevel'] = data['skillLevel'] || 3;
            comingSkill['experience'] = data['experience'] || 0.0;
            comingSkill['status'] = data['status'] || data['status'] == 0 ? data['status'] : 0;
          }
          else {
            comingSkill['skillLevel'] = comingSkill['skillLevel'] || 3;
            comingSkill['experience'] = comingSkill['experience'] || 0.0;
            comingSkill['status'] = comingSkill['status'] || 1;
          }
        })

        //It will wait until current execution is not completed
        setTimeout(() => {
          this.options = ev;
        }, 200)

      }
      else {
        let arr = ev.map(data => {
          let obj = {
            skillLevel: data['skillLevel'] || 3,
            experience: data['experience'] || 0.0,
            status: data['status'] || 1,
          }
          return Object.assign(data, obj)
        })
        this.options = arr;
      }
    }
    else {
      this.options = [];
    }
  }
  detectChanges(ev) {
    console.log(ev)
    // this.optionChanges.emit(this.options);
  }
  statusChanged(ev, index) {
    if (ev) {
      console.log(ev)
      this.options[index].status = ev.checked ? 1 : 0
    }

    // this.optionChanges.emit(this.options);
  }

  ngOnChanges(ev) {
    // if (ev && ev.options) {
    //   this.options = ev.options.currentValue;
    // }
  }
  close() {
    this.dialog_ref.close()
  }
  save() {
    if (this.data && this.data.enableSkill) {
      this.dialog_ref.close({
        options: this.options,
        keySkills: this.skillForm.value.keySkills
      })
    }
    else {
      this.dialog_ref.close(this.options)
    }
  }
  mstatusChanged(ev, index) {
    if (ev) {
      this.options[index].status = ev.id;
    }
  }
}
